"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _option = _interopRequireDefault(require("../option"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Radio = function Radio(props) {
  return /*#__PURE__*/_react["default"].createElement(_option["default"], _extends({
    type: "radio"
  }, props));
};
Radio.displayName = 'Radio';
Radio.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A flag indicating that the radio input is in an error state.
   */
  error: _propTypes["default"].bool,
  /**
   * A message to display when the radio input is in an error state. Wrapped in a `FieldStatus`
   * component by default.
   */
  errorMessage: _propTypes["default"].node
} : {};
var _default = exports["default"] = Radio;